import Vue from "vue";
// @ts-ignore
import Vuetify, { VSnackbar, VIcon } from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
  components: { VSnackbar, VIcon },
  iconfont: "md",
});
